import axios from 'axios';

import {
  GET_TUTORIALS, LOADING_TUTORIALS, CLEAR_ERRORS
} from './types';


// Get Tutorial
export const getTutorials = () => dispatch => {
  dispatch(setTutorialLoading());
  axios
    .get('/api/tutorial')
    .then(res =>
      {
        console.log(res);
        dispatch({
          type: GET_TUTORIALS,
          payload: res.data
        })
      }
    )
    .catch(err =>
      dispatch({
        type: GET_TUTORIALS,
        payload: null
      })
    );
};

// Set loading state
export const setTutorialLoading = () => {
  return {
    type: LOADING_TUTORIALS
  };
};

export const saveOrUpdate = (data) => {
  if (data._id) {
    return axios.post('/api/tutorial/update', data); 
  }
  return axios.post('/api/tutorial/add', data);
}

export const deleteTutorial = (id) => {
  return axios.delete(`/api/tutorial/${id}`); 
}

// Clear errors
export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};
